function track({ client, value, currency, uuid }) {
  const valueFormatted = (value / 100).toFixed(2);
  return gtag('event', 'purchase', {
    transaction_id: uuid,
    affiliation: client,
    value: valueFormatted,
    currency,
  });
}
export default track;
